import React, { useState, useRef, useEffect } from 'react';
import '../../src/App.css';
import supabase from '../supabaseClient';

import racebaseLogo from '../assets/images/general/racebaseLogo_symbol_white.png';
import racebaseText from '../assets/images/general/racebaseText_whiteText.png';

import { PropagateLoader } from 'react-spinners';

// Debounce function
const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
        if (timeoutId) {
            clearTimeout(timeoutId);
        }
        timeoutId = setTimeout(() => {
            func.apply(null, args);
        }, delay);
    };
};

const ResetPassword = () => {
  const [loading, setLoading] = useState(false);
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [response, setResponse] = useState({ timeOut: null, success: null, message: null });
  const [fadeClass, setFadeClass] = useState('fade-in');
  const logoRef = useRef(null)

  useEffect(() => {
    let timeoutId;
    if (response?.timeOut) {
      timeoutId = setTimeout(()=> {
        setResponse({ timeOut: null, success: null, message: null });
      }, 2000);
    }
    return () => {
      clearTimeout(timeoutId);        //Clear the timeout if isSignUp changes
    };
  }, [response]);


  const handleResetPassword = async () => {
    if (newPassword !== confirmPassword) {
      setResponse({timeOut: false, success: false, message: 'Passwords do not match.'});
      return;
    }

    if (newPassword.length <= 5) {
      setResponse({ timeOut: false, success: false, message: 'Password must be longer than 5 letters.' });
      return; 
    }

    try {
      setLoading(true)
      const response = await callSupabaseFunction()
      console.log('response', response)
      setResponse( { timeOut: false, success: response.success, message: response.message } );
    } catch (error) {
      console.log('Error', error.message)
      setResponse({ timeOut: true, success: false, message: 'Error occurred: ' + error.message});
    } finally {
      setLoading(false)
    }
  };

  const callSupabaseFunction = async() => {
      try {
        await supabase.auth.updateUser({ password: newPassword })
        return { success: true, message: 'Password Reset Successfully! Please close this page.' }
      } catch (error) {
        console.log('Error in callRealmFunction', error.message)
        return { success: false, message: error.message }
      }
  };
  
  // Debounced function to reset response state
  const resetResponseDebounced = debounce((newMessage) => {
    setFadeClass('fade-in')
    setResponse({ success: false, message: newMessage });
  }, 300); // 300 milliseconds delay

  useEffect(() => {
      if (response.message !== "") {
        setFadeClass('fade-in-active'); // Trigger fade-in effect
      }
  }, [response.message]);

  return (
      <div className="App">
          <header className="App-header">
              <img ref={logoRef} src={racebaseLogo} className="App-logo" alt="RACEBASE_LOGO" />

              {!loading ? (
                  response.timeOut != null ? 
                    <div className={`${fadeClass} ${response.success ? 'success-message' : 'error-message'}`}>
                      <p>{response.message}</p>
                    </div>
                    : 
                    null
              ) : (
                  <div className="spinner">
                      <PropagateLoader 
                          color={'white'} 
                          loading={loading} 
                          size={10} 
                      />
                  </div>
              )}
  
              <div className="reset-password">
                  <h1>Reset Password</h1>
                  <div className="form-group">
                      <input
                          type="password"
                          placeholder="New Password"
                          value={newPassword}
                          onChange={(e) => {
                              setNewPassword(e.target.value)
                              resetResponseDebounced(null)
                          }}
                      />
                  </div>
                  <div className="form-group">
                      <input
                          type="password"
                          placeholder="Confirm Password"
                          value={confirmPassword}
                          onChange={(e) => {
                              setConfirmPassword(e.target.value)
                              resetResponseDebounced(null)
                          }}
                      />
                  </div>
                  <button onClick={handleResetPassword}>Submit</button>
              </div>
          </header>

      <div className="bottom-corner">
        <img src={racebaseText} alt="RACEBASE" className="bottom-corner-img" />
        <p className="bottom-corner-text">2024</p>
      </div>
    </div>
  );
};

export default ResetPassword;